import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { CompleteLegacyBatchBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const completeLegacyBatch = createApiThunk<void, CompleteLegacyBatchBody>(
  "batches/completeLegacyBatch",
  async (body, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.completeLegacyBatch(body);
  },
);

export const resetCompleteLegacyBatch = createAction("batches/resetCompleteLegacyBatch");
